import '../../css/base.css';
import Kayaking from './kayaking';
import BoatTrips from './boatTrips';

const OnTheWater = () => {

  return (
    <div className="row">
      <div className="col-12 col-md-6">
        <Kayaking />
      </div>
      <div className="col-12 col-md-6">
        <BoatTrips />
      </div>
    </div>
  );
}

export default OnTheWater;